import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "absolute bottom-0 inset-x-0 px-container pb-32 lg:pb-48" }, [
  /*#__PURE__*/_createVNode("h1", { class: "font-display text-center text-5xl lg:text-6xl text-amff-teal" }, " European VOD Meeting "),
  /*#__PURE__*/_createVNode("div", { class: "mt-4 text-center text-xl font-display" }, [
    /*#__PURE__*/_createVNode("div", null, "Palma de Mallorca, Balear Islands, Spain"),
    /*#__PURE__*/_createVNode("div", null, "28-30 July 2022")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" The European VoD Meetings is the first European professional training especially conceived for the Video on Demand sector. ")
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, " It is organised by EuroVoD and co-funded by the Creative Europe MEDIA Programme. The goal of the training is to reinforce the competitiveness of the European VoD platforms, preserving the richness of the cultural diversity of their catalogue, through the transmission of know-how and peer-to-peer learning, by fostering the implementation of innovative projects, producing an updated and comprehensive analysis of the needs of the sector and its opportunities, and stimulating a better comprehension of the dynamics that could influence the circulation of European, arthouse and independent films in Europe as elsewhere. The training is born from the urgency of the European VoD platforms to network and benchmark, fostering the dialogue within the chain of rights and with the service providers, feeding a knowledge economy for the benefit of all the industry and finally to the european creativity. Video on Demand is a young sector the industry based on innovation and gathering different knowledges and backgrounds in tech & film that need a constant up to date: transparency, communication, data analysis, cooperation, confrontation about the hot topics of the business, development of new projects, acquisition of technical, artistic, marketing, trading and management tools. ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("strong", null, "THE 3RD EDITION"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" In 2022 the European VoD Meetings is accessible: "),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("strong", null, "Online:"),
      /*#__PURE__*/_createTextVNode(" (in development) adapted for junior and intermediate profiles approaching the Video on Demand sector, accessible worldwide to everyone though a major online training platform ")
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("strong", null, "Residential:"),
      /*#__PURE__*/_createTextVNode(" 28, 29 and 30 July in Palma de Mallorca, for VoD executive profiles, access though the application below & selection ")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hero = _resolveComponent("Hero")
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_PageContent = _resolveComponent("PageContent")
  const _component_PageContainer = _resolveComponent("PageContainer")
  const _component_FollowFestival = _resolveComponent("FollowFestival")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Hero, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_PageContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_PageTitle, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_PageContent, null, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4,
            _createVNode("p", null, [
              _createVNode("img", {
                src: `${_ctx.baseURL}img/eurovod/banner.jpg`,
                class: "w-fullh-auto",
                loading: "lazy"
              }, null, 8, ["src"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_FollowFestival)
  ], 64))
}